// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"299dc77c","388":"645485ab","453":"b94a6442","457":"c8941217","551":"1c00abc7","851":"c1fd7df2"}[chunkId] + ".chunk.js";
};